<template>
  <div class="flex flex-col">
    <app-icon class="mb-4" icon="bx:bxs-quote-alt-right" :size="32" />

    <div class="flex items-center gap-2">
      <app-rating-stars
        v-if="testimonial.rating"
        class="mb-1"
        :size="20"
        :value="testimonial.rating"
      />

      <p>
        <strong>{{ testimonial.rating }}</strong>
        <span class="text-sm">/5</span>
      </p>
    </div>

    <p class="mb-8 flex-auto" v-html="testimonial.content" />

    <brand-testimonial-author
      :author="testimonial"
      :avatar-size="avatarSize"
      :no-company-logo="noCompanyLogo"
    />
  </div>
</template>

<script lang="ts" setup>
import type { BrandTestimonialDefinition } from "~/business-areas/brand/brand.model";

defineProps<{
  testimonial: BrandTestimonialDefinition;
  noCompanyLogo?: boolean;
  avatarSize?: number;
}>();
</script>
